<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col lg="12">
        <b-card v-if="tieneAcceso === false">
          <div slot="header">
            <strong>Casos Activos sin Cobrador/Liquidador por Ejecutivo</strong>
          </div>
          <b-row>
            <b-col lg="12">
              <p>Acceso restringido</p>
            </b-col>
          </b-row>
        </b-card>

        <b-card v-if="tieneAcceso === true">
          <div slot="header">
            <strong>Filtros del Informe</strong>
          </div>
          <b-row>
            <b-col sm="3">
              <b-form-group label="Tipo de Fecha">
                <b-form-radio v-model="datosFormulario.selected" name="some-radios" value="A">Fecha Aviso Impago</b-form-radio>
                <b-form-radio v-model="datosFormulario.selected" name="some-radios" value="I">Fecha Ingreso</b-form-radio>
              </b-form-group>
            </b-col>
            <b-col sm="3">
              <b-form-group 
                :label="crearLabel('Año Consulta', 'anio', 'datosFormulario')"
                label-for="anio">
                <b-form-input
                  id="anio"
                  type="text"
                  placeholder=""
                  v-model="datosFormulario.anio"
                  :disabled="campoBloqueado('anio', 'datosFormulario')"
                  @change="validarCampo('pkg_sinpp_informes', 'anio', $event, 'datosFormulario')">
                </b-form-input>
                <span class="error-validacion-campo">
                    {{ mensajeValidacionCampo.anio }}
                </span>
              
              </b-form-group>

              <b-form-group
                :label="crearLabel('Ejecutivo', 'codejecutivo', 'datosFormulario')"
                label-for="codejecutivo">
                <b-form-select 
                  :options="valEjecutivos"  
                  v-model="datosFormulario.ejecutivo"
                  :disabled="campoBloqueado('codejecutivo', 'datosFormulario')"
                >
                </b-form-select>
                
                <span class="error-validacion-campo">
                  {{ mensajeValidacionCampo.codejecutivo }}
                </span>
              </b-form-group>
              
            </b-col>

            <b-col sm="3">  
              
              <b-form-group
                :label="crearLabel('Origen Prórroga', 'origenpro', 'datosFormulario')"
                label-for="origenpro">
                <b-form-select 
                  :options="valOrigen"  
                  v-model="datosFormulario.origenpro"
                  :disabled="campoBloqueado('origenpro', 'datosFormulario')"
                >
                </b-form-select>
                
                <span class="error-validacion-campo">
                  {{ mensajeValidacionCampo.origenpro }}
                </span>
              </b-form-group>
            </b-col>

            
            
          </b-row>

          <div slot="footer">
                <div class="form-actions">
                    <el-row>
                            <el-col>
                                <b-button variant="primary" @click="buscar"><i class="fa fa-search"></i> Consultar</b-button>
                                <b-button variant="primary" @click="pre_insertar"><i class="fa fa-eraser"></i> Limpiar</b-button>
                                <b-button variant="primary" @click="descargarExcel"><i class="fa fa-file-excel-o"></i> Exportar</b-button>
                            </el-col> 
                               
                    </el-row>                
                </div>
            </div>            
        </b-card>

        <b-card v-if="tieneAcceso === true">
          <div slot="header">
            <strong>Casos activos con documentos pendientes y sin asignar a cobranza</strong>
          </div>
          <b-row>
            <b-col lg="6">
              
            </b-col>
            <b-col lg="6">
              <b-form-group label label-for="filtroProceso">
                <b-form-input
                  id="filtroProceso"
                  type="text"
                  placeholder="Filtrar"
                  v-model="filters[0].value"
                ></b-form-input>
              </b-form-group>
            </b-col>
          </b-row>
          <br>
          <b-row>
            <b-col lg="12">
              <div ref="refTable">
              <data-tables ref="refTable1"
                :data="data"
                name="table"
                class="table-responsive"
                :current-page.sync="pagina"
                :table-props="tableProps2"
                :filters="filters"
                :page-size="10"
                :pagination-props="{ background: true, pageSizes: [10, 20, 50] }"
                layout="table"
              >
                <el-table-column
                  v-for="title in titlesDinamic"
                  :prop="title.prop"
                  :label='title.label'
                  :key="title.label"
                  :align="title.align"
                  sortable="custom"
                  :formatter="formatter"
                  name="table"
                  class="table-responsive"
                ></el-table-column>
                
              </data-tables>
              </div>
            </b-col>
          </b-row>
        </b-card>

        <b-card v-if="tieneAcceso === true">
          <div slot="header">
            <strong>Casos activos sin documentos pendientes y sin asignar a cobranza</strong>
          </div>
          <b-row>
            <b-col lg="6">
              
            </b-col>
            <b-col lg="6">
              <b-form-group label label-for="filtroProceso">
                <b-form-input
                  id="filtroProceso2"
                  type="text"
                  placeholder="Filtrar"
                  v-model="filters2[0].value"
                ></b-form-input>
              </b-form-group>
            </b-col>
          </b-row>
          <br>
          <b-row>
            <b-col lg="12">
              <data-tables 
                :data="data2"
                :current-page.sync="pagina"
                :table-props="tableProps2"
                :filters="filters2"
                :page-size="10"
                :pagination-props="{ background: true, pageSizes: [10, 20, 50] }"
                layout="table"
              >
                <el-table-column
                  v-for="title in titlesDinamic2"
                  :prop="title.prop"
                  :label="title.label"
                  :key="title.label"
                  :align="title.align"
                  sortable="custom"
                  :formatter="formatter"
                ></el-table-column>
                
              </data-tables>
            </b-col>
          </b-row>
        </b-card>
      
        <b-card v-if="tieneAcceso === true">
          <div slot="header">
            <strong>Casos activos con documentos pendientes y sin asignar a liquidador</strong>
          </div>
          <b-row>
            <b-col lg="6">
              
            </b-col>
            <b-col lg="6">
              <b-form-group label label-for="filtroProceso">
                <b-form-input
                  id="filtroProceso2"
                  type="text"
                  placeholder="Filtrar"
                  v-model="filters3[0].value"
                ></b-form-input>
              </b-form-group>
            </b-col>
          </b-row>
          <br>
          <b-row>
            <b-col lg="12">
              <data-tables 
                :data="data3"
                :current-page.sync="pagina"
                :table-props="tableProps2"
                :filters="filters3"
                :page-size="10"
                :pagination-props="{ background: true, pageSizes: [10, 20, 50] }"
                layout="table"
              >
                <el-table-column
                  v-for="title in titlesDinamic3"
                  :prop="title.prop"
                  :label="title.label"
                  :key="title.label"
                  :align="title.align"
                  sortable="custom"
                  :formatter="formatter"
                ></el-table-column>
                
              </data-tables>
            </b-col>
          </b-row>
        </b-card>

        <b-card v-if="tieneAcceso === true">
          <div slot="header">
            <strong>Casos activos sin documentos pendientes y sin asignar a liquidador</strong>
          </div>
          <b-row>
            <b-col lg="6">
              
            </b-col>
            <b-col lg="6">
              <b-form-group label label-for="filtroProceso">
                <b-form-input
                  id="filtroProceso2"
                  type="text"
                  placeholder="Filtrar"
                  v-model="filters4[0].value"
                ></b-form-input>
              </b-form-group>
            </b-col>
          </b-row>
          <br>
          <b-row>
            <b-col lg="12">
              <data-tables 
                :data="data4"
                :current-page.sync="pagina"
                :table-props="tableProps2"
                :filters="filters4"
                :page-size="10"
                :pagination-props="{ background: true, pageSizes: [10, 20, 50] }"
                layout="table"
              >
                <el-table-column
                  v-for="title in titlesDinamic4"
                  :prop="title.prop"
                  :label="title.label"
                  :key="title.label"
                  :align="title.align"
                  sortable="custom"
                  :formatter="formatter"
                ></el-table-column>
                
              </data-tables>
            </b-col>
          </b-row>
        </b-card>

      </b-col>
    </b-row>
    
  </div>
</template>
<script>
import { Switch as cSwitch } from "@coreui/vue";
import axios from "axios";
import { tablasMixin } from "@/components/mixins/tablasMixin";
import apiInformes from "@/components/services/apiInformes";
import { globalesMixin } from "@/components/mixins/globalesMixin";
import { utilesMixin } from "@/components/mixins/utilesMixin";
import Datepicker from "vuejs-datepicker";
import { es } from "vuejs-datepicker/dist/locale";
import moment from 'moment';
import download from "downloadjs";
import numeral from "numeral";

import XLSX from "xlsx";

export default {
  name: "CasosActivosSinCobradorLiquidadorEjecutivo",
  mixins: [tablasMixin, globalesMixin, utilesMixin],
  components: {
    cSwitch
  },
  data: function() {
    return {
      exportar: false,
      tieneAcceso: true,
      es: es,
      busqueda: "",
      pagina: 1,
      paginaAnterior: 1,
      labelIcon: {
        dataOn: "\u2713",
        dataOff: "\u2715"
      },

      data: [],
      data2: [],
      data3: [],
      data4: [],
      nombreexcel: "CasosActivosSinCobradorLiquidadorEjecutivo",
      titlesDinamic: [],
      filters: [
        {
          prop: [],
          value: ""
        }
      ],
      titlesDinamic2: [],
      filters2: [
        {
          prop: [],
          value: ""
        }
      ],
      titlesDinamic3: [],
      filters3: [
        {
          prop: [],
          value: ""
        }
      ],
      titlesDinamic4: [],
      filters4: [
        {
          prop: [],
          value: ""
        }
      ],


      datosFormulario: {
        anio: "", 
        ejecutivo: "", 
        origenpro: "",
        selected: ""
      },

      valEjecutivos: [],
      valOrigen: [],
      datosFormularioEstado: [],
      mensajeValidacionCampo: {},

      tableProps2:{
          summaryMethod: this.totales,
          showSummary: true
      },
    };
  },
  components:{
    Datepicker
  },
  methods: {
    mergeArrayObjects(arr1,arr2){
      return arr1.map((item,i)=>{
        if(item.id === arr2[i].id){
            //merging two objects
          return Object.assign({},item,arr2[i])
        }
      })
    },

    formatNumber(n) {
      console.log(n);
        n = String(n).replace(/\D/g, "");
        return n === '' ? n : Number(n).toLocaleString();
    },

    totales(param) {
 
      const { columns, data } = param;

      const sums = [];

      columns.forEach((column, index) => {
          if (index === 0) {
              sums[index] = 'Total';
              return;
          }

          const values = data.map(item => Number(item[column.property]));

          if (!values.every(value => isNaN(value))) {
              sums[index] = this.$numeral((values.reduce((prev, curr) => {
                  const value = Number(curr);

                  if (!isNaN(value)) {
                      return prev + curr;
                  } else {
                      return prev;
                  }
              }, 0))).format();
             /*
             sums[index] = values.reduce((prev, curr) => {
                  const value = Number(curr);

                  if (!isNaN(value)) {
                      return prev + curr;
                  } else {
                      return prev;
                  }
              }, 0);
              */
          } else {
              sums[index] = '';
          }
      });

      return sums;
    },

    exportarExcel() {
        this.$nextTick(function() {
          var tabla = document.getElementById("tableExcel");
          var data = XLSX.utils.table_to_sheet(tabla);
          const workbook = XLSX.utils.book_new();
          const filename = "Export";
          XLSX.utils.book_append_sheet(workbook, data, filename);
          XLSX.writeFile(workbook, `${filename}.xlsx`);
        });
    },
    
    cargarColumnasGrilla(data){
      this.titlesDinamic = [];
      
      for (var key in data) {
          for (var key2 in data[key]) {
              let arrAux = [];
              arrAux["prop"] = key2;
              arrAux["label"] = key2.replace("'","").replace("'","");
              arrAux["align"] = "left";
              if (key2 != "Ejecutivo"){
                arrAux["align"] = "right";
              }
              this.titlesDinamic.push(arrAux);
              this.filters[0].prop.push(key2);       
          }
          return;
      }
          
    },

    cargarColumnasGrilla2(data){
      this.titlesDinamic2 = [];
      
      for (var key in data) {
          for (var key2 in data[key]) {
              let arrAux = [];
              arrAux["prop"] = key2;
              arrAux["label"] = key2.replace("'","").replace("'","");
              arrAux["align"] = "left";
              if (key2 != "Ejecutivo"){
                arrAux["align"] = "right";
              }
              this.titlesDinamic2.push(arrAux);
              this.filters2[0].prop.push(key2);       
          }
          return;
      }
          
    },

    cargarColumnasGrilla3(data){
      this.titlesDinamic3 = [];
      
      for (var key in data) {
          for (var key2 in data[key]) {
              let arrAux = [];
              arrAux["prop"] = key2;
              arrAux["label"] = key2.replace("'","").replace("'","");
              arrAux["align"] = "left";
              if (key2 != "Ejecutivo"){
                arrAux["align"] = "right";
              }
              this.titlesDinamic3.push(arrAux);
              this.filters3[0].prop.push(key2);       
          }
          return;
      }          
    },

    cargarColumnasGrilla4(data){
      this.titlesDinamic4 = [];
      
      for (var key in data) {
          for (var key2 in data[key]) {
              let arrAux = [];
              arrAux["prop"] = key2;
              arrAux["label"] = key2.replace("'","").replace("'","");
              arrAux["align"] = "left";
              if (key2 != "Ejecutivo"){
                arrAux["align"] = "right";
              }
              this.titlesDinamic4.push(arrAux);
              this.filters4[0].prop.push(key2);       
          }
          return;
      }          
    },

    pre_insertar() {
      this.exportar = false;
      this.mensajeValidacionCampo = {};
      this.data = [];
      this.data2 = [];
      this.data3 = [];
      return apiInformes
        .pre_insercion(
          this.$session.get("mail"),
          this.$session.get("usuarioInterno")
        )
        .then(response => {
          response.data = this.keysMinuscula(response.data);

          //Bloqueo usuario no valido
          if (response.data.args_out.usuarioval == 's'){
            this.tieneAcceso = true;
          }else{
            this.tieneAcceso = false;
          }
          
          var lista_data = response.data.res;
          for(var i = 0; i < lista_data.length; i++){
              this.datosFormulario.anio = lista_data[i]["anio"];
              this.datosFormulario.ejecutivo = lista_data[i]["codejecutivo"];
              this.datosFormulario.origenpro = lista_data[i]["origenpro"];
              this.datosFormulario.selected = lista_data[i]["selected"];
          }
         
      
          this.datosFormularioEstado = response.data.festado;
          
          //Carga lista de ejecutivos
          var tiposEjecutivos = new Array();
          var lista_tipos_ejecutivos = response.data.ejecutivos;
          for(var i = 0; i < lista_tipos_ejecutivos.length; i++){
              var obj = new Object();
              obj.value = lista_tipos_ejecutivos[i]["codejecutivo"];
              obj.text = lista_tipos_ejecutivos[i]["des_ejecutivo"];
              tiposEjecutivos.push(obj);
          }
          this.valEjecutivos = tiposEjecutivos;

          //Carga lista de origen
          var tiposOrigen = new Array();
          var lista_tipos_origen = response.data.origenpro;
          for(var i = 0; i < lista_tipos_origen.length; i++){
              var obj = new Object();
              obj.value = lista_tipos_origen[i]["origenpro"];
              obj.text = lista_tipos_origen[i]["desc_origenpro"];
              tiposOrigen.push(obj);
          }
          this.valOrigen = tiposOrigen;
          

        })
        .catch(error => {
          this.crearNotificacion("Error de sistema", error, "error");
        });
    },

    buscar() {
      this.$Progress.start();

      return apiInformes
        .	InformeCasosActivosSinCobradorLiquidadorEjecutivo(
          this.$session.get("mail"),
          this.$session.get("usuarioInterno"),
          this.datosFormulario.anio, 
          this.datosFormulario.ejecutivo, 
          this.datosFormulario.origenpro,
          this.datosFormulario.selected
        )
        .then(response => {
          //response.data = this.keysMinuscula(response.data);

          this.data  = response.data.res1;
          this.data2 = response.data.res2;
          this.data3 = response.data.res3;
          this.data4 = response.data.res4;
          this.pagina = this.paginaAnterior;
          this.$Progress.finish();

          
          if (this.data != null){
            this.exportar = true;
          } else {
            this.exportar = false;
          }
          
                    
          this.cargarColumnasGrilla(this.data);
          this.cargarColumnasGrilla2(this.data2);
          this.cargarColumnasGrilla3(this.data3);
          this.cargarColumnasGrilla4(this.data4);

          //this.formatPieTotalTabla(this.$refs.refTable1);
        })
        .catch(error => {
          this.crearNotificacion("Error de sistema", error, "error");
        });
    },

    formatter(row, column) {
      if (column.property == "prifmodif" && row[column.property]) {
        return this.configurarFechaLat(this.convierteFecha(row[column.property]));
      } else if (column.property != "Ejecutivo" && row[column.property]) {
        column.align = "is-right";
        return this.$numeral(row[column.property]).format();
      } else {
        return row[column.property];
      }
    },
    
    cargarColumnasDinamicas(data){
      var titlesDinamic = [];
      
      for (var key in data) {
          for (var key2 in data[key]) {
              titlesDinamic.push(key2);     
          }
          return titlesDinamic;
      }
      
    },

    descargarExcel: function(){
      var cuerpo = "";
      var columnas = this.cargarColumnasDinamicas(this.data);

      var xl159618 = "padding:0px; mso-ignore:padding; color:black; font-size:11.0pt; font-weight:400; font-style:normal; text-decoration:none; font-family:Calibri, sans-serif; mso-font-charset:0; mso-number-format:General; text-align:general; vertical-align:bottom; mso-background-source:auto; mso-pattern:auto; white-space:nowrap;";
      var xl689618 = "padding:0px; mso-ignore:padding; color:black; font-size:12.0pt; font-weight:700; font-style:normal; text-decoration:none; font-family:Calibri, sans-serif; mso-font-charset:0; mso-number-format:General; text-align:center; vertical-align:middle; border-top:.5pt solid windowtext; border-right:.5pt solid windowtext; border-bottom:.5pt solid windowtext; border-left:.5pt solid windowtext; background:#BDD7EE; mso-pattern:black none; white-space:nowrap;";
      var xl649618 = "padding:0px; mso-ignore:padding; color:black; font-size:11.0pt; font-weight:400; font-style:normal; text-decoration:none; font-family:Calibri, sans-serif; mso-font-charset:0; mso-number-format:General; text-align:general; vertical-align:bottom; border:.5pt solid windowtext; mso-background-source:auto; mso-pattern:auto; white-space:nowrap;";
      var xl679618 = "padding:0px; mso-ignore:padding; color:black; font-size:11.0pt; font-weight:400; font-style:normal; text-decoration:none; font-family:Calibri, sans-serif; mso-font-charset:0; mso-number-format:General; text-align:center; vertical-align:bottom; border:.5pt solid windowtext; mso-background-source:auto; mso-pattern:auto; white-space:nowrap;";
      var xl719618 = "padding:0px; mso-ignore:padding; color:black; font-size:12.0pt; font-weight:700; font-style:normal; text-decoration:none; font-family:Calibri, sans-serif; mso-font-charset:0; mso-number-format:General; text-align:center; vertical-align:middle; border-top:.5pt solid windowtext; border-right:.5pt solid windowtext; border-bottom:.5pt solid windowtext; border-left:.5pt solid windowtext; mso-background-source:auto; mso-pattern:auto; white-space:nowrap; mso-rotate:90;";
      var xl659618 = "padding:0px; mso-ignore:padding; color:black; font-size:11.0pt; font-weight:700; font-style:normal; text-decoration:none; font-family:Calibri, sans-serif; mso-font-charset:0; mso-number-format:General; text-align:general; vertical-align:bottom; border:.5pt solid windowtext; mso-background-source:auto; mso-pattern:auto; white-space:nowrap;";

      cuerpo += "<table border=0 cellpadding=0 cellspacing=0 width=730 style='border-collapse:collapse;table-layout:fixed;width:550pt'>";
      cuerpo += "\n";
      cuerpo += "<col width=32 style='mso-width-source:userset;mso-width-alt:1170;width:24pt'>";
      cuerpo += "\n";
      cuerpo += "<col width=130 style='mso-width-source:userset;mso-width-alt:4754;width:98pt'>";
      cuerpo += "\n";
      cuerpo += "<col width=61 span=8 style='mso-width-source:userset;mso-width-alt:2230; width:46pt'>";
      cuerpo += "\n";
      cuerpo += "<col width=80 style='width:60pt'>";
      cuerpo += "\n";

      cuerpo += "<tr height=28 style='mso-height-source:userset;height:21.0pt'>\n";
        cuerpo += "<td height=28 class=xl159618 width=32 style='height:21.0pt;width:24pt;"+xl159618+"'></td>\n";
        cuerpo += "<td colspan="+columnas.length+" class=xl689618 width=698 style='width:526pt;"+xl689618+"'>Casos activos sin cobrador/liquidador por ejecutivo</td>\n";
      cuerpo += "</tr>\n";

      cuerpo += "<tr height=28 style='mso-height-source:userset;height:21.0pt'>\n";
        cuerpo += "<td height=28 class=xl159618 style='height:21.0pt;"+xl159618+"'></td>\n";
        cuerpo += "<td colspan="+columnas.length+" class=xl689618 style='border-right:.5pt solid black;"+xl689618+"'>Año consultado "+this.datosFormulario.anio+"</td>\n";
      cuerpo += "</tr>\n";

      cuerpo += "<tr height=20 style='height:15.0pt'>\n";
        cuerpo += "<td height=20 class=xl159618 style='height:15.0pt;"+xl159618+"'></td>\n";
        cuerpo += "<td class=xl159618 style='"+xl159618+"'></td>\n";
        cuerpo += "<td class=xl159618 style='"+xl159618+"'></td>\n";
        cuerpo += "<td class=xl159618 style='"+xl159618+"'></td>\n";
        cuerpo += "<td class=xl159618 style='"+xl159618+"'></td>\n";
        cuerpo += "<td class=xl159618 style='"+xl159618+"'></td>\n";
        cuerpo += "<td class=xl159618 style='"+xl159618+"'></td>\n";
        cuerpo += "<td class=xl159618 style='"+xl159618+"'></td>\n";
        cuerpo += "<td class=xl159618 style='"+xl159618+"'></td>\n";
        cuerpo += "<td class=xl159618 style='"+xl159618+"'></td>\n";
        cuerpo += "<td class=xl159618 style='"+xl159618+"'></td>\n";
      cuerpo += "</tr>\n";

      //Titulos columnas bloque 1
      cuerpo += "<tr height=26 style='mso-height-source:userset;height:19.5pt'>\n";
        cuerpo += "<td height=26 class=xl159618 style='height:19.5pt;"+xl159618+"'></td>\n";
        cuerpo += "<td colspan="+columnas.length+" class=xl689618 style='border-right:.5pt solid black;"+xl689618+"'>Casos activos con doc. pendientes y sin asignar a cob.</td>\n";
      cuerpo += "</tr>\n";

      cuerpo += "<tr height=20 style='height:15.0pt'>\n";
        cuerpo += "<td height=20 class=xl159618 style='height:15.0pt;"+xl159618+"'></td>\n";
        for (var i=0; i<columnas.length; i++) {
          cuerpo += "<td class=xl679618 style='border-left:none;"+xl679618+"'>"+columnas[i]+"</td>\n";
        }
      cuerpo += "</tr>\n";


      //Data bloque 1
      var cont = 0;
      var sumdata1 = [];
      sumdata1["N° de Casos"] = 0;
      sumdata1["Promedio días desde el aviso"] = 0;
      for (var key in this.data) {
        cuerpo += "<tr height=20 style='mso-height-source:userset;height:15.0pt'>\n";
          sumdata1["N° de Casos"] += this.data[key]["N° de Casos"];
          sumdata1["Promedio días desde el aviso"] += this.data[key]["Promedio días desde el aviso"];

          if (cont == 0){
          cuerpo += "<td rowspan="+ (Object.keys(this.data).length + 1) +" height=280 class=xl719618 style='height:210.0pt;"+xl719618+"'>Ejecutivos</td>\n";
          }
          cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;"+xl649618+"'>"+this.data[key]["Ejecutivo"]+"</td>\n";
          cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;"+xl649618+"'>"+this.data[key]["N° de Casos"]+"</td>\n";
          cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;"+xl649618+"'>"+this.data[key]["Promedio días desde el aviso"]+"</td>\n";
        cuerpo += "</tr>\n";
        cont += 1;
      }

      cuerpo += "<tr height=20 style='height:15.0pt'>\n";
        cuerpo += "<td height=20 class=xl659618 style='height:15.0pt;border-top:none;border-left: none;"+xl659618+"'>Total casos</td>\n";
        cuerpo += "<td class=xl659618 align=right style='border-top:none;border-left:none;"+xl659618+"'>"+sumdata1["N° de Casos"]+"</td>\n";
        cuerpo += "<td class=xl659618 align=right style='border-top:none;border-left:none;"+xl659618+"'>"+sumdata1["Promedio días desde el aviso"]+"</td>\n";
      cuerpo += "</tr>\n";


      
      //Titulos columnas bloque 2
      cuerpo += "<tr height=20 style='height:15.0pt'>\n";
      cuerpo += "</tr>\n";

      columnas = this.cargarColumnasDinamicas(this.data2);
      cuerpo += "<tr height=26 style='mso-height-source:userset;height:19.5pt'>\n";
        cuerpo += "<td height=26 class=xl159618 style='height:19.5pt;"+xl159618+"'></td>\n";
        cuerpo += "<td colspan="+columnas.length+" class=xl689618 style='border-right:.5pt solid black;"+xl689618+"'>Casos activos sin doc. pendientes y sin asignar a cob.</td>\n";
      cuerpo += "</tr>\n";

      cuerpo += "<tr height=20 style='height:15.0pt'>\n";
        cuerpo += "<td height=20 class=xl159618 style='height:15.0pt;"+xl159618+"'></td>\n";
        for (var i=0; i<columnas.length; i++) {
          cuerpo += "<td class=xl679618 style='border-left:none;"+xl679618+"'>"+columnas[i]+"</td>\n";
        }
      cuerpo += "</tr>\n";
      
      //Data bloque 2
      var cont = 0;
      var sumdata2 = [];
      sumdata2["N° de Casos"] = 0;
      sumdata2["Promedio días desde el aviso"] = 0;
      for (var key in this.data2) {
        cuerpo += "<tr height=20 style='mso-height-source:userset;height:15.0pt'>\n";
          sumdata2["N° de Casos"] += this.data2[key]["N° de Casos"];
          sumdata2["Promedio días desde el aviso"] += this.data2[key]["Promedio días desde el aviso"];

          if (cont == 0){
          cuerpo += "<td rowspan="+ (Object.keys(this.data2).length + 1) +" height=280 class=xl719618 style='height:210.0pt;"+xl719618+"'>Ejecutivos</td>\n";
          }
          cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;"+xl649618+"'>"+this.data2[key]["Ejecutivo"]+"</td>\n";
          cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;"+xl649618+"'>"+this.data2[key]["N° de Casos"]+"</td>\n";
          cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;"+xl649618+"'>"+this.data2[key]["Promedio días desde el aviso"]+"</td>\n";
        cuerpo += "</tr>\n";
        cont += 1;
      }

      cuerpo += "<tr height=20 style='height:15.0pt'>\n";
        cuerpo += "<td height=20 class=xl659618 style='height:15.0pt;border-top:none;border-left: none;"+xl659618+"'>Total casos</td>\n";
        cuerpo += "<td class=xl659618 align=right style='border-top:none;border-left:none;"+xl659618+"'>"+sumdata2["N° de Casos"]+"</td>\n";
        cuerpo += "<td class=xl659618 align=right style='border-top:none;border-left:none;"+xl659618+"'>"+sumdata2["Promedio días desde el aviso"]+"</td>\n";
      cuerpo += "</tr>\n";


      //Titulos columnas bloque 3
      cuerpo += "<tr height=20 style='height:15.0pt'>\n";
      cuerpo += "</tr>\n";

      columnas = this.cargarColumnasDinamicas(this.data3);
      cuerpo += "<tr height=26 style='mso-height-source:userset;height:19.5pt'>\n";
        cuerpo += "<td height=26 class=xl159618 style='height:19.5pt;"+xl159618+"'></td>\n";
        cuerpo += "<td colspan="+columnas.length+" class=xl689618 style='border-right:.5pt solid black;"+xl689618+"'>Casos activos con doc. pendientes y sin asignar a liq.</td>\n";
      cuerpo += "</tr>\n";

      cuerpo += "<tr height=20 style='height:15.0pt'>\n";
        cuerpo += "<td height=20 class=xl159618 style='height:15.0pt;"+xl159618+"'></td>\n";
        for (var i=0; i<columnas.length; i++) {
          cuerpo += "<td class=xl679618 style='border-left:none;"+xl679618+"'>"+columnas[i]+"</td>\n";
        }
      cuerpo += "</tr>\n";
      
      //Data bloque 3
      var cont = 0;
      var sumdata3 = [];
      sumdata3["N° de Casos"] = 0;
      sumdata3["Promedio días desde el aviso"] = 0;
      for (var key in this.data3) {
        cuerpo += "<tr height=20 style='mso-height-source:userset;height:15.0pt'>\n";
          sumdata3["N° de Casos"] += this.data3[key]["N° de Casos"];
          sumdata3["Promedio días desde el aviso"] += this.data3[key]["Promedio días desde el aviso"];

          if (cont == 0){
          cuerpo += "<td rowspan="+ (Object.keys(this.data3).length + 1) +" height=280 class=xl719618 style='height:210.0pt;"+xl719618+"'>Ejecutivos</td>\n";
          }
          cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;"+xl649618+"'>"+this.data3[key]["Ejecutivo"]+"</td>\n";
          cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;"+xl649618+"'>"+this.data3[key]["N° de Casos"]+"</td>\n";
          cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;"+xl649618+"'>"+this.data3[key]["Promedio días desde el aviso"]+"</td>\n";
        cuerpo += "</tr>\n";
        cont += 1;
      }

      cuerpo += "<tr height=20 style='height:15.0pt'>\n";
        cuerpo += "<td height=20 class=xl659618 style='height:15.0pt;border-top:none;border-left: none;"+xl659618+"'>Total casos</td>\n";
        cuerpo += "<td class=xl659618 align=right style='border-top:none;border-left:none;"+xl659618+"'>"+sumdata3["N° de Casos"]+"</td>\n";
        cuerpo += "<td class=xl659618 align=right style='border-top:none;border-left:none;"+xl659618+"'>"+sumdata3["Promedio días desde el aviso"]+"</td>\n";
      cuerpo += "</tr>\n";


      //Titulos columnas bloque 4
      cuerpo += "<tr height=20 style='height:15.0pt'>\n";
      cuerpo += "</tr>\n";

      columnas = this.cargarColumnasDinamicas(this.data4);
      cuerpo += "<tr height=26 style='mso-height-source:userset;height:19.5pt'>\n";
        cuerpo += "<td height=26 class=xl159618 style='height:19.5pt;"+xl159618+"'></td>\n";
        cuerpo += "<td colspan="+columnas.length+" class=xl689618 style='border-right:.5pt solid black;"+xl689618+"'>Casos activos sin doc. pendientes y sin asignar a liq.</td>\n";
      cuerpo += "</tr>\n";

      cuerpo += "<tr height=20 style='height:15.0pt'>\n";
        cuerpo += "<td height=20 class=xl159618 style='height:15.0pt;"+xl159618+"'></td>\n";
        for (var i=0; i<columnas.length; i++) {
          cuerpo += "<td class=xl679618 style='border-left:none;"+xl679618+"'>"+columnas[i]+"</td>\n";
        }
      cuerpo += "</tr>\n";
      
      //Data bloque 4
      var cont = 0;
      var sumdata4 = [];
      sumdata4["N° de Casos"] = 0;
      sumdata4["Promedio días desde el aviso"] = 0;
      for (var key in this.data4) {
        cuerpo += "<tr height=20 style='mso-height-source:userset;height:15.0pt'>\n";
          sumdata4["N° de Casos"] += this.data4[key]["N° de Casos"];
          sumdata4["Promedio días desde el aviso"] += this.data4[key]["Promedio días desde el aviso"];

          if (cont == 0){
          cuerpo += "<td rowspan="+ (Object.keys(this.data4).length + 1) +" height=280 class=xl719618 style='height:210.0pt;"+xl719618+"'>Ejecutivos</td>\n";
          }
          cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;"+xl649618+"'>"+this.data4[key]["Ejecutivo"]+"</td>\n";
          cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;"+xl649618+"'>"+this.data4[key]["N° de Casos"]+"</td>\n";
          cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;"+xl649618+"'>"+this.data4[key]["Promedio días desde el aviso"]+"</td>\n";
        cuerpo += "</tr>\n";
        cont += 1;
      }

      cuerpo += "<tr height=20 style='height:15.0pt'>\n";
        cuerpo += "<td height=20 class=xl659618 style='height:15.0pt;border-top:none;border-left: none;"+xl659618+"'>Total casos</td>\n";
        cuerpo += "<td class=xl659618 align=right style='border-top:none;border-left:none;"+xl659618+"'>"+sumdata4["N° de Casos"]+"</td>\n";
        cuerpo += "<td class=xl659618 align=right style='border-top:none;border-left:none;"+xl659618+"'>"+sumdata4["Promedio días desde el aviso"]+"</td>\n";
      cuerpo += "</tr>\n";
      
      
      this.export(this.generaExcelV2(this.nombreexcel, cuerpo),this.nombreexcel);
    },

    export:async function(data, filename) {
      if(typeof this.beforeFinish === 'function')
        await this.beforeFinish();
      download(data, filename,  "application/vnd.ms-excel");
    },

    convierteFecha(fechaEntrada){
        if((fechaEntrada != undefined) && (fechaEntrada.length != 0)){
            var fecha = new Date(fechaEntrada);

            var dia = ("0" + fecha.getUTCDate()).slice(-2);
            var mes = ("0" + (fecha.getUTCMonth() + 1)).slice(-2)
            var año = fecha.getUTCFullYear();

            fecha = dia + '-' + mes + '-' + año;

            return fecha;
        }
        else{
            return fechaEntrada;
        }
    },

  },
  mounted() {
    this.pagina = Number(this.$route.query.pagina);
    this.pre_insertar();
    this.buscar();
  },
  watch: {
    pagina: function(nuevo, anterior) {
      this.paginaAnterior = anterior;
    }
  }
};
</script>
